// extracted by mini-css-extract-plugin
export default {"h1":"PageContent_h1__v7yHe","h6":"PageContent_h6__jSF9U","content":"PageContent_content__bYZgT","image":"PageContent_image__4Fmi3"};